<template>
  <div class="controls-body" :style="{position: showControls ? 'relative' : 'absolute'}">
    <div class="hidden-panel tip" @click="toggleControls" style="cursor:pointer">
      <font-awesome-icon
        :icon="['fas', 'caret-square-down']"
        :style="{transform: showControls ? 'rotate(90deg)' : ''}"
      />
    </div>

    <div class="control-container">
      <div class="controls" v-if="showControls">
        <div >
           <div class="open-panel control-btn" @click="$emit('toggleMenu')" v-if="!menuState">Open toolbox</div>
           <div class="open-panel control-btn" @click="$emit('toggleMenu')" v-else>Close toolbox</div>
        </div>
        <!-- <div
          class="margins control-btn tip"
          v-if="showingMargins"
          @click="toggleMargins"
        >
          <font-awesome-icon :icon="['fas', 'arrows-alt-v']" />
          <span class="tooltiptext">Hide margins between controls</span>
        </div>
        <div class="margins control-btn tip" v-else @click="toggleMargins">
          <font-awesome-icon :icon="['fas', 'arrows-alt-v']" />
          <hr class="strike" />
          <span class="tooltiptext">Show margins between controls</span>
        </div> -->
        <div
          class="change-layout control-btn tip"
          @click="$emit('openSelectLayout')"
        >
          <font-awesome-icon :icon="['fas', 'list-ul']" />
          <span class="tooltiptext">Change layout</span>
        </div>
        <div class="default-btn" @click="setDefault" v-if="canEdit">Set as default</div>
        <div class="save-btn" @click="$emit('openSave')" v-if="canEdit">Save Layout</div>
      </div>
    </div>
    <popup ref="confirm"></popup>
  </div>
</template>
<script>
export default {
  props:{
    menuState: Boolean,
    canEdit: Boolean
  },
  data() {
    return {
      showControls: false,
      showingMargins: true,
      locked: true,
      showGlobalFilters: false,
      globalConfig: {
        campaignNames: [],
      },
    };
  },
  methods: {
    toggleControls(){
      this.showControls = !this.showControls
      this.locked = !this.showControls;
      this.$emit("toggleLock");
    },
    toggleMargins() {
      this.showingMargins = !this.showingMargins;
      this.$emit("toggleMargins");
    },
    addCampaign(name) {
      this.globalConfig.campaignNames.push(name);
      this.$store.getters.agentArgs.addCampaignName(name);
      this.$store.getters.campaignArgs.addCampaignName(name);
      this.$store.getters.queueArgs.addCampaignName(name);

      this.$emit(
        "changeConfigs",
        "campaignNames",
        this.globalConfig.campaignNames
      );
    },
    removeCampaign(name) {
      var index = this.globalConfig.campaignNames.indexOf(name);
      this.$store.getters.agentArgs.removeCampaignName(name);
      this.$store.getters.campaignArgs.removeCampaignName(name);
      this.$store.getters.queueArgs.removeCampaignName(name);

      if (index !== -1) {
        this.globalConfig.campaignNames.splice(index, 1);
      }
      this.$emit(
        "changeConfigs",
        "campaignNames",
        this.globalConfig.campaignNames
      );
    },
    async setDefault() {
      var confirm = await this.$refs.confirm.show({
        title: "Set default layout",
        message: `Are you sure you want to set this layout as the default for ${this.$diamond.identity}?`,
        okButton: "Set Default",
        isConfirm: true
      });

      if (confirm) {
        this.$diamond
          .setDefaultLayout(this.$store.getters.currentLayout)
          .then(() => {
            this.$toast(
              "success",
              `Layout with id ${this.$store.getters.currentLayout} set as default successfully`
            );
          });
      }
    },
  },
};
</script>

<style scoped>
.controls-body{
  display:flex;
  flex-direction: row-reverse;
  position: absolute;
  top: 0;
  right: 10px;
}

.hidden-panel {
  width: 40px;
  height: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.2em;
  z-index: 2;
}

.control-container {
  z-index: 2;
}

.control-btn {
  border-radius: 6px;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3em;
  color: white;
  margin-right: 10px;
  position: relative;
  cursor: pointer;
}

.tip .tooltiptext {
  visibility: hidden;
  min-width: 100px;
  background-color: #303030;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  font-size: 12pt;
  position: absolute;
  z-index: 1;
  top: 103%;
  left: 0;
}

.tip:hover .tooltiptext {
  visibility: visible;
}

.locked {
  background-color: #f71735;
}

.unlocked {
  background-color: #70b77e;
}

.controls {
  display: flex;
  padding: 10px;
  position: relative;
}

.open-panel {
  background-color: #303030;
  width:auto !important;
  height: 36px;
  padding: 0 10px;
  font-size:16px;
}

.global-filter {
  background-color: #4287f5;
}

.global-filters {
  position: absolute;
  background-color: white;
  border: 1px solid rgb(48, 48, 48, 0.3);
  padding: 10px;
  width: 500px;
  margin-top: 5px;
  margin-left: -50px;
}

.margins {
  position: relative;
  background-color: rosybrown;
}

.strike {
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: white;
  outline: none;
  border: none;
  transform: rotate(-45deg);
}

.save-btn {
  border-radius: 6px;
  height: 36px;
  padding: 0 10px;
  background-color: #0186c9;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.change-layout {
  background-color: #9171ba;
}

.config-text {
  margin: 5px 10px 20px 10px;
}

.default-btn {
  border-radius: 6px;
  height: 36px;
  padding: 0 10px;
  background-color: #0186c9;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 10px;
}
</style>
